 $(window).on("drawer_open_done", function() {
    if (window.Zapiet && window.ZapietCachedSettings) {
      Zapiet.start(ZapietCachedSettings);
    }
 });

$(window).on("cart_update_done", function() {
  if (window.Zapiet && window.ZapietCachedSettings) {
    Zapiet.start(ZapietCachedSettings);
  }
});/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
